import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export interface DropdownActivatorSignature {
  Args: object;
  Blocks: {
    default: [];
  };
  Element: null;
}

export default class DropdownActivator<
  T = DropdownActivatorSignature,
> extends Component<T> {
  @tracked dropdownIsActivated = false;

  @action
  populateDomWithDropdown() {
    if (!this.dropdownIsActivated) this.dropdownIsActivated = true;
  }
}
